import type { ActionParams } from '@swf/components/StarsMPNotification/config/NotificationTypes';
import { dispatch } from '@swf/core/store';

import defaultHeaderImg from '../../assets/images/default-chest-header.png';
import ChestNotificationView from '../../components/ChestReward/ChestReward';
import { ActionType } from '../../enums';

import {
  TXTCLI_YouXve_been_awarded_N0_ChestsX,
  TXTWCL_View_all_Chests
} from './ChestReward.multiple.config.messages.json';

export default {
  front: {
    view: ChestNotificationView,
    viewConfig: {
      title: { tag: TXTCLI_YouXve_been_awarded_N0_ChestsX, values: { 0: 'numberOfChests' } },
      defaultHeaderImageURL: defaultHeaderImg,
      showCloseIcon: true,
      actions: [
        {
          actionType: ActionType.Primary,
          actionLabel: { tag: TXTWCL_View_all_Chests },
          href: '/account/my-stars/chest-inventory',
          actionFunction: ({ notificationId }: ActionParams) =>
            dispatch.notification.delete({ notificationId })
        }
      ]
    }
  }
};
